export default __webpack_public_path__ + "static/media/profile.56b39824.svg";